module.exports = __webpack_public_path__ + "img/memberFour.0d869d0a.svg";